import React from 'react';
import { useTheme } from 'emotion-theming';

const LinkedIn = ({ color, ...props }) => {
    const theme = useTheme();
    const iconColor = color ? color : theme.colorMap.greyLightTwo;
    return (
        <svg
            aria-label="LinkedIn"
            width="20"
            height="20"
            viewBox="0 0 635 540"
            {...props}
        >
            <g
                transform="translate(0,540) scale(0.1,-0.1)"
                fill={iconColor}
                stroke="none"
            >
                <path
                    d="M283 5386 c-136 -43 -247 -167 -273 -307 -14 -70 -14 -4647 0 -4718
                23 -121 113 -235 227 -289 l58 -27 2390 0 2390 0 58 27 c114 54 204 168 227
                289 14 72 14 4648 0 4720 -23 120 -113 233 -227 287 l-58 27 -2375 2 c-1944 1
                -2383 -1 -2417 -11z m1109 -778 c94 -47 176 -130 221 -225 30 -64 32 -74 32
                -184 0 -113 -1 -116 -38 -191 -202 -410 -791 -317 -857 135 -24 165 69 357
                216 443 90 53 139 65 250 62 93 -3 107 -6 176 -40z m2384 -1169 c446 -49 681
                -286 759 -764 27 -162 35 -472 28 -1162 l-6 -673 -388 0 -388 0 -3 768 c-4
                750 -4 769 -25 844 -42 147 -101 226 -206 274 -57 27 -71 29 -182 29 -139 0
                -205 -16 -281 -68 -91 -62 -143 -153 -181 -312 -14 -61 -17 -165 -20 -802 l-4
                -733 -390 0 -389 0 0 1270 0 1270 375 0 375 0 0 -170 c0 -181 7 -202 43 -141
                36 61 110 142 180 197 197 154 409 206 703 173z m-2186 -1329 l0 -1270 -390 0
                -390 0 0 1270 0 1270 390 0 390 0 0 -1270z"
                />
                <path
                    d="M5863 726 c-65 -21 -128 -62 -167 -107 -146 -171 -115 -429 67 -553
                271 -183 628 44 576 366 -20 124 -95 223 -209 276 -67 31 -199 40 -267 18z
                m205 -51 c69 -21 147 -86 186 -155 28 -50 31 -63 31 -145 0 -75 -4 -98 -24
                -139 -76 -155 -261 -224 -413 -154 -197 91 -251 339 -109 501 82 93 207 128
                329 92z"
                />
                <path
                    d="M5840 370 l0 -200 30 0 30 0 0 85 0 85 33 0 c29 0 36 -7 85 -85 51
                -81 55 -85 89 -85 43 0 42 3 -27 105 -48 71 -49 75 -27 75 13 0 35 13 50 28
                22 22 27 38 27 76 0 95 -33 116 -185 116 l-105 0 0 -200z m211 121 c24 -30 24
                -46 -1 -71 -16 -16 -33 -20 -85 -20 l-65 0 0 61 0 61 66 -4 c55 -3 70 -8 85
                -27z"
                />
            </g>
        </svg>
    );
};

export default LinkedIn;
